import type { ViewDefinition } from '@powerportalspro/react-fluent';

// The React twin of the Blazor demo's `FileUploadCustomViews.cs`: the same view id and FetchXML,
// so both stacks show the same files.

export const ALL_FILES_VIEW_ID = '8c92a1d4-e5b7-4f31-9a62-3d8c7b1f4e02';

/**
 * Every file the user may read: the shared sample files, and a signed-in user's own uploads. The
 * view needs no filter for it — the table's row security narrows every query to those rows.
 */
export function getAllFilesView(): ViewDefinition {
  return {
    id: ALL_FILES_VIEW_ID,
    tableName: 'ppp_file',
    fetchXml: `<fetch>
      <entity name="ppp_file">
        <attribute name="ppp_filename" />
        <attribute name="ppp_data" />
        <attribute name="ppp_owningportaluserid" />
        <attribute name="ownerid" />
        <attribute name="createdon" />
        <order attribute="createdon" descending="true" />
      </entity>
    </fetch>`,
    columns: [
      { columnName: 'ppp_filename', width: 350 },
      { columnName: 'ppp_data', width: 300 },
      { columnName: 'createdon', width: 200 },
    ],
  };
}
